export default __webpack_public_path__ + "locales/de/EmptyTrashDialog.json?hash=aa58735e337e531ff806afc9ea672b53";